export default __webpack_public_path__ + "static/media/our-process-01.f8367dc3.jpg";